import { AUTOCOLON_ADD_ITEM, AUTOCOLON_DELETE_ITEM, AUTOCOLON_SEARCH_VALUE, AUTOCOLON_SELECT_ITEM, AUTOCOLON_SET_ITEM, AUTOCOLONS_SET_ITEMS, DIVISION_ADD_ITEM, DIVISION_DELETE_ITEM, DIVISION_SET_ITEM, DIVISION_SET_ITEMS, GEOFENSE_SET_SEARCH_VALUE } from 'app/utils/constants';

export const setSearchValue = (value) => {
    return {
        type: 'TRANSPORT_SET_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};

export const setSelectedItem = (data) => {
    return {
        type: 'TRANSPORT_SET_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setSortSelectedItem = (data) => {
    return {
        type: 'TRANSPORT_SET_SORT_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const deleteCheckedItem = (id) => {
    return {
        type: 'TRANSPORT_DELETE_CHECKED_ITEM',
        payload: {
            id,
        },
    };
};

export const addCheckedItem = (id) => {
    return {
        type: 'TRANSPORT_ADD_CHECKED_ITEM',
        payload: {
            id,
        },
    };
};

export const setCanGenerationItems = (items) => {
    return {
        type: 'TRANSPORT_SET_CAN_GENERATION_ITEMS',
        payload: {
            items,
        },
    };
};

export const setGroupSelectedItem = (data) => {
    return {
        type: 'TRANSPORT_GROUP_SET_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setGroupSearchValue = (value) => {
    return {
        type: 'TRANSPORT_GROUP_SET_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};

export const setGroupSelectedItemTransportItems = (items) => {
    return {
        type: 'TRANSPORT_GROUP_SET_SELECTED_ITEM_TRANSPORT_ITEMS',
        payload: {
            items,
        },
    };
};

export const updateItem = (data) => {
    return {
        type: 'TRANSPORT_UPDATE_ITEM',
        payload: {
            data,
        },
    };
};

export const setGroupTypeItems = (items) => {
    return {
        type: 'TRANSPORT_GROUP_SET_TYPE_ITEMS',
        payload: {
            items,
        },
    };
};

export const setItems = (items) => {
    return {
        type: 'TRANSPORT_SET_ITEMS',
        payload: {
            items,
        },
    };
};

export const updateItems = (data) => {
    return {
        type: 'TRANSPORT_UPDATE_ITEMS',
        payload: {
            data,
        },
    };
};

export const addItem = (data) => {
    return {
        type: 'TRANSPORT_ADD_ITEM',
        payload: {
            data,
        },
    };
};

export const deleteItem = (id) => {
    return {
        type: 'TRANSPORT_DELETE_ITEM',
        payload: {
            id,
        },
    };
};

export const setInspectionItems = (items) => {
    return {
        type: 'TRANSPORT_SET_SELECTED_ITEM_INSPECTION_ITEMS',
        payload: {
            items,
        },
    };
};

export const setInspectionSelectedItem = (data) => {
    return {
        type: 'TRANSPORT_SET_INSPECTION_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setTypeItems = (items) => {
    return {
        type: 'TRANSPORT_TYPE_SET_ITEMS',
        payload: {
            items,
        },
    };
};

export const setModelItems = (items) => {
    return {
        type: 'TRANSPORT_MODEL_SET_ITEMS',
        payload: {
            items,
        },
    };
};

export const addGroupItem = (data) => {
    return {
        type: 'TRANSPORT_GROUP_ADD_ITEM',
        payload: {
            data,
        },
    };
};

export const updateGroupItem = (data) => {
    return {
        type: 'TRANSPORT_GROUP_UPDATE_ITEM',
        payload: {
            data,
        },
    };
};

export const setGroupItems = (items) => {
    return {
        type: 'TRANSPORT_GROUP_SET_ITEMS',
        payload: {
            items,
        },
    };
};

export const deleteGroupItem = (id) => {
    return {
        type: 'TRANSPORT_GROUP_DELETE_ITEM',
        payload: {
            id,
        },
    };
};

export const setGroupCheckListItems = (items) => {
    return {
        type: 'TRANSPORT_GROUP_SET_CHECKLIST_ITEMS',
        payload: {
            items,
        },
    };
};

export const setGroupCheckListSelectedItem = (data) => {
    return {
        type: 'TRANSPORT_GROUP_SET_CHECKLIST_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const updateGroupSelectedItemCheckListItem = (data) => {
    return {
        type: 'TRANSPORT_GROUP_UPDATE_CHECKLIST_ITEM',
        payload: {
            data,
        },
    };
};

export const addGroupSelectedItemCheckListItem = (data) => {
    return {
        type: 'TRANSPORT_GROUP_ADD_CHECK_LIST_ITEM',
        payload: {
            data,
        },
    };
};

export const setAutocolonItems = (data) => {
    return {
        type: AUTOCOLONS_SET_ITEMS,
        payload: {
            data,
        },
    };
};

export const setDivisionItems = (data) => {
    return {
        type: DIVISION_SET_ITEMS,
        payload: {
            data,
        },
    };
};

export const setAutocolonSelectItem = (value) => {
    return {
        type: AUTOCOLON_SELECT_ITEM,
        payload: {
            value,
        },
    };
};
export const setAutocolonSearchValue = (value) => {
    return {
        type: AUTOCOLON_SEARCH_VALUE,
        payload: {
            value,
        },
    };
};
export const setAutocolonItem = (item) => {
    return {
        type: AUTOCOLON_SET_ITEM,
        payload: {
            item,
        },
    };
};

export const setDivisionItem = (item) => {
    return {
        type: DIVISION_SET_ITEM,
        payload: {
            item,
        },
    };
};

export const addDivisionItem = (data) => {
    return {
        type: DIVISION_ADD_ITEM,
        payload: {
            data,
        },
    };
};

export const addAutocolonItem = (data) => {
    return {
        type: AUTOCOLON_ADD_ITEM,
        payload: {
            data,
        },
    };
};

export const deleteDivisionItem = (id) => {
    return {
        type: DIVISION_DELETE_ITEM,
        payload: {
            id,
        },
    };
};

export const deleteAutocolonItem = (id) => {
    return {
        type: AUTOCOLON_DELETE_ITEM,
        payload: {
            id,
        },
    };
};

export const setGeofenceSearchValue = (value) => {
    return {
        type: GEOFENSE_SET_SEARCH_VALUE,
        payload: {
            value,
        },
    };
};
